import { render, staticRenderFns } from "./a-icon-minimal.vue?vue&type=template&id=ab7bd594&"
import script from "./a-icon-minimal.vue?vue&type=script&lang=js&"
export * from "./a-icon-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports